// Cookie value to set as valid agreement value.
const COOKIE_EXISTS = '1';
// Cookie key to set as log agreement.
const LOG_AGREEMENT_COOKIE = 'agreementCookie';

/**
 * Check if log agreement does not exist in cookie to show KVKK modal.
 * @returns {boolean} - Whether KVKK should be shown or not.
 */
const shouldShowKvkkModal = () => getCookieByKey(LOG_AGREEMENT_COOKIE) != COOKIE_EXISTS;

/**
 * Read cookie value from "document" by given key.
 * @param {string} key - Cookie key saved in document.
 * @returns {string} - Corresponding cookie value if it exists.
 */
const getCookieByKey = (key) => {
  const keyWithPrefix = key + '=';
  const decodedCookie = decodeURIComponent(document.cookie);
  const cookieList = decodedCookie.split(';');
  for (let i = 0; i < cookieList.length; i++) {
    let cookie = cookieList[i];
    while (cookie.charAt(0) == ' ') {
      cookie = cookie.substring(1);
    }
    if (cookie.indexOf(keyWithPrefix) == 0) {
      return cookie.substring(keyWithPrefix.length, cookie.length);
    }
  }
  return '';
};

/**
 * Get next month based on the current date.
 * @returns {Date} - Date of next month based on the current date.
 */
const getNextMonthExpiryDate = () => {
  const dateTimestamp = new Date();
  // Add 1 month buffer to the current date.
  const monthBuffer = (dateTimestamp.getMonth() + 1) % 12;
  return new Date(dateTimestamp.setMonth(monthBuffer));
};

/**
 * Set document cookie to be expired at next month.
 */
export const setFlormarAgreementCookie = () => {
  const expiryDate = getNextMonthExpiryDate();
  document.cookie = `${LOG_AGREEMENT_COOKIE}=${COOKIE_EXISTS}; expires=${expiryDate.toUTCString()}; SameSite=None; Secure`;
};

/**
 * Open KVKK Modal exclusive for Flormar if it meets the condition.
 */
export const openFlormarKvkkModal = () => {
  if (!shouldShowKvkkModal()) return;

  $('#flormar-kvkk-modal')
    .modal({
      backdrop: 'static',
      keyboard: false,
    })
    .show();
  $('body').addClass('nonscroll');
};

/**
 * Close KVKK Modal exclusive for Flormar when user has accepted the terms.
 */
export const closeFlormarKvkkModal = () => {
  $('#flormar-kvkk-modal').hide();
  $('body').removeClass('nonscroll');
};

/**
 * Set action buttons classes based on the active button.
 * If "Go to product" button is active, "Add to cart" button should be shown as single button.
 * Otherwise, "Add to cart" button should be shown as double button.
 */

export const setActionButtonsClasses = () => {
  const addToCartButton = $('.action-buttons .add-to-cart-btn');
  const goToProductButton = $('.action-buttons .go-to-product-btn');
  const hasGoToProductActiveClass = goToProductButton.hasClass('active');

  if (!hasGoToProductActiveClass) {
    addToCartButton.addClass('single-btn');
    return;
  }
  addToCartButton.removeClass('single-btn');
};
